import { render, staticRenderFns } from "./SystemMessageTriggerOverview.vue?vue&type=template&id=54bf8e36&scoped=true"
import script from "./SystemMessageTriggerOverview.vue?vue&type=script&lang=ts"
export * from "./SystemMessageTriggerOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bf8e36",
  null
  
)

export default component.exports